// @ts-check
import React from 'react';

import { useDispatch } from 'react-redux';
import { editRouteOptimisationStartEndLoationsAction } from '../redux/actions/settings-actions';

import { Formik } from 'formik';

import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';

import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  },
  sectionHeading: {
    margin: theme.spacing(2)
  },
  margin: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  formButtons: {
    marginTop: theme.spacing(0),
    paddingBottom: theme.spacing(1)
  },
  errorText: {
    color: '#f44336',
    textAlign: 'center',
    display: 'block',
    margin: theme.spacing(3)
  }
}));

function EditRouteOptimisationStartEndLocationsForm(props) {
  const classes = useStyles();

  const { values, errors, touched, handleSubmit, handleChange, handleBlur } = props;

  /**
   * @param {string} name
   */
  const formikProps = (name, initialValue = '') => ({
    name: name,
    value: typeof values[name] !== 'undefined' ? values[name] : initialValue,
    onChange: handleChange,
    onBlur: handleBlur,
    error: touched[name] && Boolean(errors[name]),
    helperText: touched[name] ? errors[name] : ''
  });

  return (
    <form className={classes.root} noValidate autoComplete="off" onSubmit={handleSubmit}>
      <FormControl component="fieldset">
        <FormLabel component="legend">
          Select the drivers Start and End location for Route Optimisation
        </FormLabel>
        <FormGroup aria-label="ro_start_end_locations" {...formikProps('ro_start_end_locations')}>
          <FormControlLabel
            value={'start_at_branch'}
            control={<Checkbox checked={values.selected.includes('start_at_branch')} />}
            name="selected"
            label="Start at the branch"
          />
          <FormControlLabel
            value={'end_at_branch'}
            control={<Checkbox checked={values.selected.includes('end_at_branch')} />}
            name="selected"
            label="End at the branch"
          />
        </FormGroup>
      </FormControl>

      <div className={classes.formButtons}>
        <>
          <Button
            className={classes.margin}
            type="submit"
            variant="contained"
            size="large"
            color="primary"
            fullWidth={true}
          >
            Save Changes
          </Button>
        </>
      </div>
    </form>
  );
}

/** The boxes to tick when the form opens: the stored choices (it used to open with neither ticked). */
export const startEndSelected = (route_optimisation) => {
  const locations = route_optimisation?.ro_start_end_locations || {};
  return ['start_at_branch', 'end_at_branch'].filter((key) => locations[key] === true);
};

export function EditRouteOptimisationStartEndLocationsFormComponent({
  route_optimisation,
  openBackdrop,
  closeBackdrop,
  showSnackbar,
  handleClose
}) {
  const dispatch = useDispatch();

  const values = {
    selected: startEndSelected(route_optimisation)
  };

  const submit = (data, actions) => {
    openBackdrop();

    let value;

    if (data.selected.length === 0) {
      value = {
        ro_start_end_locations: {
          start_at_branch: false,
          end_at_branch: false
        }
      };
    } else if (data.selected.length === 2) {
      value = {
        ro_start_end_locations: {
          start_at_branch: true,
          end_at_branch: true
        }
      };
    } else {
      if (data.selected == 'end_at_branch') {
        value = {
          ro_start_end_locations: {
            start_at_branch: false,
            end_at_branch: true
          }
        };
      } else {
        value = {
          ro_start_end_locations: {
            start_at_branch: true,
            end_at_branch: false
          }
        };
      }
    }

    const { resetForm } = actions;
    const props = { resetForm, closeBackdrop, showSnackbar, handleClose };
    dispatch(editRouteOptimisationStartEndLoationsAction(value, props));
  };

  return (
    <Formik initialValues={values} onSubmit={submit}>
      {(props) => <EditRouteOptimisationStartEndLocationsForm {...props} />}
    </Formik>
  );
}
